module.exports = {"231123001":"奇克街道","231123100":"奇克镇","231123101":"逊河镇","231123102":"逊克县克林镇","231123201":"干岔子乡","231123202":"松树沟乡","231123203":"车陆乡","231123204":"新鄂乡","231123205":"新兴乡","231123207":"宝山乡","231123402":"道干林场","231123403":"干岔子林场","231123404":"新立林场","231123405":"三间房林场","231123406":"良种场","231123407":"种畜场","231123500":"逊克农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231123.json
// module id = 728
// module chunks = 0